function Header() {
    const SCROLL_OFFSET = 0;

    // ====== Selector cache
    const $doc = $(document);
    const $win = $(window);
    const $header = $(".header");
    const $nav = $(".header-nav");
    const $bars = $(".header-bars");
    const $acc = $(".header-nav-acc");
    const HCOL = ".header-nav-acc-item-collapse";
    const HITEM = ".header-nav-acc-item";

    // ====== Menü: aç/kapat + dışarı tıkla
    $bars.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        $nav.toggleClass("active");
        $bars.toggleClass("close");
    });
    $doc.on("click", (e) => {
        if (!$(e.target).closest(".header-nav, .header-bars").length) {
            $nav.removeClass("active");
            $bars.removeClass("close");
        }
    });

    // ====== Akordeon helpers (tek açık)
    const openAcc = ($it) => {
        const el = $it.children(HCOL).get(0);
        if (!el) return;
        $it.addClass("active");
        el.style.height = el.scrollHeight + "px";
    };
    const closeAcc = ($it) => {
        const el = $it.children(HCOL).get(0);
        if (!el) return;
        $it.removeClass("active");
        el.style.height = 0;
    };

    // ilk yüklemede hepsini kapat
    $acc.find(HCOL).each(function () {
        this.style.height = 0;
    });

    // ====== Smooth scroll (yalnızca header içi anchor)
    const rootEl = document.scrollingElement || document.documentElement;
    const esc = (s) =>
        window.CSS && CSS.escape
            ? CSS.escape(s)
            : s.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
    const targetTop = ($t) => {
        const smt =
            parseInt(getComputedStyle($t[0]).scrollMarginTop || "0", 10) || 0;
        return Math.max(0, $t.offset().top - SCROLL_OFFSET - smt);
    };
    const scrollToId = (id) => {
        const $t = $("#" + esc(id));
        if (!$t.length) return;
        $(rootEl).stop(true, true);
        const prev = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = "auto";
        $(rootEl).animate({ scrollTop: targetTop($t) }, 500, "swing", () => {
            // lazy-load sonrası tek düzeltme
            setTimeout(() => {
                const t = targetTop($t);
                if (Math.abs(rootEl.scrollTop - t) > 2)
                    $(rootEl).stop(true, true).animate({ scrollTop: t }, 200);
                document.documentElement.style.scrollBehavior = prev || "";
            }, 120);
        });
    };

    // Header içi anchor tıklama
    $header.on("click", "a[href^='#']:not([href='#'])", function (e) {
        const key = (this.hash || "").slice(1).trim();
        if (!key || !$("#" + esc(key)).length) return;
        e.preventDefault();
        $nav.removeClass("active");
        $bars.removeClass("close");
        scrollToId(key);
        history.pushState(null, "", "#" + key);
    });

    // ====== Comp1 ile senkron: tab -> akordeon
    const syncAccByKey = (key) => {
        const $open = $acc.children(`${HITEM}.active`);
        if (!key) return $open.length && closeAcc($open);
        const $parent = $(`.header-nav-acc-item-collapse#${key}`).closest(
            HITEM
        );
        if (!$parent.length) return;
        closeAcc($open.not($parent));
        if (!$parent.hasClass("active")) openAcc($parent);
    };

    // Comp1'den gelen özel event
    window.addEventListener("tabchange", (e) => {
        syncAccByKey(e.detail && e.detail.key);
    });

    // Hash uygulayıcı (ilk yükleme + back/forward)
    const applyHash = () => {
        const key = (location.hash || "").slice(1).trim();
        if (key) {
            syncAccByKey(key);
            scrollToId(key);
        } else {
            syncAccByKey(null);
        }
    };
    if (location.hash) applyHash();
    window.addEventListener("popstate", applyHash);

    // Resize: açık panel yüksekliğini güncelle
    $win.on("resize", () => {
        const el = $acc.children(".active").children(HCOL).get(0);
        if (el) el.style.height = el.scrollHeight + "px";
    });
}
Header();
